import { ProgressBarShape as FluentProgressBarShapeBase, ProgressBarThickness as FluentProgressBarThicknessBase, ProgressBarValidationState as FluentProgressBarValidationStateBase } from "@fluentui/web-components";
/** Shape values for {@link ProgressBar}. */
export const ProgressBarShapes = { ...FluentProgressBarShapeBase };
/** Thickness values for {@link ProgressBar}. */
export const ProgressBarThicknesses = {
    ...FluentProgressBarThicknessBase
};
/** Validation state values for {@link ProgressBar}. */
export const ProgressBarValidationStates = {
    ...FluentProgressBarValidationStateBase
};
//# sourceMappingURL=progress-bar.options.js.map